const RESERVE_WITH_GOOGLE_QUERY_PARAM = 'rwg_token';

export const parseTokenFromQueryParams = () => {
  const query = window?.location?.search?.substring(1);
  const params = query ? query.split('&') : [];
  let rwgToken = undefined;
  for (let i = 0; i < params.length; ++i) {
    const [key, value] = params[i].split('=');
    if (key === RESERVE_WITH_GOOGLE_QUERY_PARAM) {
      rwgToken = decodeURIComponent(value);
      break;
    }
  }
  return rwgToken;
};
